import { fcUserCatalogItem } from "@interfaces/fc-user/fc-user";
import { OrganizationCalendarI } from "@interfaces/organizationI";
import { AvailableTimesI } from "@interfaces/scheduler";
import { HealthCareI, ReasonByServiceI } from "@interfaces/search";
import { DirectoryAvailableI, 
    ICreatedService, 
    NewServiceI, 
    ReasonI, 
    ServiceI, 
    ServicesShownStatus,
    ServiceItemI,
    ServiceDetailI } from "@interfaces/services/services";
import drpServicesServiceApiInstance from "@services/clients/drproxservices";
import axiosApiInstance from "@services/custom-axios-instance";
import { generateUrl } from "@services/generateUrl/generateUrl";

 export function getReasons(lang: string, organizationId: number, searchTitle: string, userName: string) {
    return axiosApiInstance
        .get(
            `${generateUrl()}/drproxservices/catalog/reasonvisit/user/${userName}/lang/${lang}/organization/${organizationId}?searchTitle=${searchTitle}`
        )
        .then((response) => {
            const reasonsVisit = response.data as unknown;
            return reasonsVisit as ReasonI[];
        });
}

/**
 * @deprecated
 */
export function getServices(lang: string, organizationId: number, userName: string, appOrigin: string) {
    return axiosApiInstance
        .get(
            `${generateUrl()}/drproxservices/practitioner/healthcareservice/user/${userName}/lang/${lang}/organization/${organizationId}?appOrigin=${appOrigin}`
        )
        .then((response) => {
            const reasonsVisit = response.data as unknown;
            return reasonsVisit as ServiceI[];
        });
}

/**
 * @deprecated
 */
export async function getUserServices(organizationId: number, userName: string, appOrigin: string, roleCode: string) 
{
    const query = new URLSearchParams();
    query.append("appOrigin", appOrigin);
    query.append("roleCode", roleCode);
    const url = `${generateUrl()}/drproxservices/practitioner/healthcareservice/user/${userName}/organization/${organizationId}?${query.toString()}`;
    const response = await axiosApiInstance.get(url);
    const reasonsVisit = response.data as unknown;
    return reasonsVisit as ServiceI[];
}

export function deactivateServices(serviceId: number, isActive: boolean) {
    return axiosApiInstance
        .put(
            `${generateUrl()}/drproxservices/practitioner/healthcareservice/${serviceId}/${isActive}`
        )
        .then((response) => {
            const reasonsVisit = response.data as unknown;
            return reasonsVisit as {
                code: string,
                message: string,
                response: string
              };
        });
}

export function RelatedReasons(reasons: {
    practitionerHealhcareServiceId: number,
    reasonsVisit: ReasonI[]
    }) {
    return axiosApiInstance
        .post(
            `${generateUrl()}/drproxservices/practitioner/service/reasonvisit`,
            reasons
        )
        .then((response) => {
            const reasonsVisit = response.data as unknown;
            return reasonsVisit as { code: string, message: string, response: string};
        });
}

export function getReasonsByService(serviceId: number, lang: string) {
    return axiosApiInstance
        .get(
            `${generateUrl()}/drproxservices/practitioner/service/reasonvisit/${serviceId}/lang/${lang}`
        )
        .then((response) => {
            const reasonsVisit = response.data as unknown;
            return reasonsVisit as ReasonByServiceI;
        });
}

export function getHealthcareservices(lang: string, organizationId: number, userName: string) {
    return axiosApiInstance
        .get(
            `${generateUrl()}/drproxservices/catalog/healthcareservice/user/${userName}/lang/${lang}/organization/${organizationId}`
        )
        .then((response) => {
            const services = response.data as unknown;
            return services as NewServiceI[];
        });
}

export function geService(lang: string, serviceId: number, appOrigin: string) {
    return axiosApiInstance
        .get(
            `${generateUrl()}/drproxservices/practitioner/healthcareservice/${serviceId}/${lang}?appOrigin=${appOrigin}`
        )
        .then((response) => {
            const services = response.data as unknown;
            return services as ServiceI;
        });
}

export function postHealthcareservices(service: ServiceI, isCloned: boolean) {
    return axiosApiInstance
        .post(
            `${generateUrl()}/drproxservices/practitioner/healthcareservice?isCloned=${isCloned}`,
            service
            )
            .then((response) => {
                const services = response.data as unknown;
                return services as ServiceI;
            });
        }

export function putHealthcareservices(service: ServiceI) {
    return axiosApiInstance
        .put(
            `${generateUrl()}/drproxservices/practitioner/healthcareservice`,
            service
            )
            .then((response) => {
                const services = response.data as unknown;
                return services as ServiceI;
            });
        }
        
export function postReasonVisit(newReason: {description: string, organizationId: number, practitionerReasonVisitLabelId: 0, username: string}) {
    return axiosApiInstance
        .post(
        `${generateUrl()}/drproxservices/catalog/reasonvisit`,
        newReason
    )
    .then((response) => {
        const reason = response.data as unknown;
        return reason as {description: string, organizationId: number, practitionerReasonVisitLabelId: number, username: string, reasonVisitId: number};
    });
}

export async function postService(data: {description: string, organizationId: number, username: string}): Promise<ICreatedService>
{
    const endpoint = "/catalog/healthcareservice";
    const response = await drpServicesServiceApiInstance.post<ICreatedService>(endpoint, data);
    return response.data;
}

export function getPractitionerOrganization(userName: string) {
        return axiosApiInstance
            .get(
                `${generateUrl()}/drproxservices/practitioner/profile/organization/${userName}`
            )
            .then((response) => {
                const services = response.data as unknown;
                return services as OrganizationCalendarI[];
            });
    }
export async function getPractitionerOrganizationM(userName: string) {
    const endpoint = `practitioner/contract/profile/organization/${userName}`; 
    const response = await drpServicesServiceApiInstance.get<OrganizationCalendarI[]>(endpoint);
    return response.data;
}
export async function getPractitionerOrganizationM2(userName: string) {
    const endpoint = `practitioner/contract/profile/organization/${userName}/v2`; 
    const response = await drpServicesServiceApiInstance.get<OrganizationCalendarI[]>(endpoint);
    return response.data;
}
export async function createPractitionerOrganization(practitionerUsername: string)
{
    const endpoint = `/organization/default/user/${practitionerUsername}`;
    const response = await drpServicesServiceApiInstance.put(endpoint);
    return response.status;
}

export function postAvailableTimes(times: AvailableTimesI) {
    return axiosApiInstance
        .post(
            `${generateUrl()}/drproxservices/healthcareservice/available/time`,
            times
        )
        .then((response) => {
            const res = response.data as unknown;
            return res as AvailableTimesI;
        });
}

export function getAvailableTimes(
    organizationStructureId: number,
    healthcareServiceid: number
) {
    return axiosApiInstance
        .get(
            `${generateUrl()}/drproxservices/healthcareservice/available/time/${healthcareServiceid}/${organizationStructureId}`
        )
        .then((response) => {
            const res = response.data as unknown;
            return res as AvailableTimesI;
        });
}

export function getAvailableDirectories(appOrigin: string){
    return axiosApiInstance
        .get(`${generateUrl()}/drproxservices/catalog/additional/platform/${appOrigin}`)
        .then((response) => {
            const res = response.data as unknown;
            return res as DirectoryAvailableI[];
        });
}

export function getShownAllServices(appOrigin: string, organizationPractitionerContractId: number){
    return axiosApiInstance
        .get(
            `${generateUrl()}/drproxservices/practitioner/contract/directory?appOrigin=${appOrigin}&organizationPractitionerContractId=${organizationPractitionerContractId}`
        )
        .then((response) => {
            const res = response.data as unknown;
            return res as ServicesShownStatus;
        });
}

export function putShownAllServices(data: Omit<ServicesShownStatus, "name">, organizationPractitionerContractId: number ){
    return axiosApiInstance
        .put(
            `${generateUrl()}/drproxservices/practitioner/contract/directory?appOrigin=${data.appOrigin}&isVisible=${data.isVisible}&organizationPractitionerContractId=${organizationPractitionerContractId}`
        )
        .then((response) => {
            const res = response.data as unknown;
            return res;
        });
}

export function getHealthCareCatalog(languageCode: string) {
    return axiosApiInstance
        .get(
            `${generateUrl()}/drproxservices/catalog/service/${languageCode}`
        )
        .then((response) => {
            const data = response.data as unknown;
            return data as HealthCareI[];
        });
}

export async function getServicesList( practitionerUsername: string, organizationId: number | null, isOwner: boolean): Promise<ServiceItemI[]> {
    const serviceEndpoint = `/api/v1/practitioner/${practitionerUsername}/service`;
    const organizationEndpoint = `/api/v1/practitioner/organization/${organizationId}/service`;
    const endpoint = isOwner ? serviceEndpoint : organizationEndpoint;
    const response = await drpServicesServiceApiInstance.get<ServiceItemI[]>(endpoint);
    return response.data;
}

export async function getServicesListPractitionerByOrganization(organizationId: number, isOwner: boolean, practitionerUsername:string): Promise<ServiceItemI[]> {
    const serviceEndpoint = `/api/v1/practitioner/${practitionerUsername}/service`;
    const organizationEndpoint = `/api/v1/practitioner/services/${organizationId}/${practitionerUsername}`;
    const endpoint = isOwner ? serviceEndpoint : organizationEndpoint;
    const response = await drpServicesServiceApiInstance.get<ServiceItemI[]>(endpoint);
    return response.data;
}

export function getReasonsServiceCatalog(lang: string) {
    return axiosApiInstance
        .get(
            `${generateUrl()}/fc-dr-catalogs/api/v1/reason/visit`,
            {
                headers: {
                    Lang: `${lang}`,
                }
            }
        )
        .then((response) => {
            const reasonsVisit = response.data as unknown;
            return reasonsVisit as fcUserCatalogItem[];
        });
}
export function getHealthcareservicesCatalog(lang: string) {
    return axiosApiInstance
        .get(
            `${generateUrl()}/fc-dr-catalogs/api/v1/healthcare/service`,
            {
                headers: {
                    Lang: `${lang}`,
                }
            }
        )
        .then((response) => {
            const services = response.data as unknown;
            return services as fcUserCatalogItem[];
        });
}
export function postNewReasonVisit(newReason: {description: string, organizationId: number, practitionerReasonVisitLabelId: 0, username: string}) {
    return axiosApiInstance
        .post(
        `${generateUrl()}/drproxservices/catalog/reasonvisit`,
        newReason
    )
    .then((response) => {
        const reason = response.data as unknown;
        return reason as {description: string, organizationId: number, practitionerReasonVisitLabelId: number, username: string, reasonVisitId: number};
    });
}
export async function addPractitionerService( serviceData: ServiceDetailI): Promise<ServiceDetailI> {
    const endpoint = "/api/v1/practitioner/service/";
    const response = await drpServicesServiceApiInstance.post<ServiceDetailI>(endpoint,serviceData);
    return response.data;
}
export async function updatePractitionerService( serviceData: ServiceDetailI, serviceId:string): Promise<ServiceDetailI> {
    const endpoint = `/api/v1/practitioner/service/${serviceId}`;
    const response = await drpServicesServiceApiInstance.put<ServiceDetailI>(endpoint,serviceData);
    return response.data;
}
export async function getServiceDetail( serviceId: string): Promise<ServiceDetailI> {
    const endpoint = `/api/v1/practitioner/service/${serviceId}`;
    const response = await drpServicesServiceApiInstance.get<ServiceDetailI>(endpoint);
    return response.data;
}

export async function updateStatusServiceDetail( serviceId: string, statusFlag: boolean): Promise<ServiceDetailI> {
    const endpoint = `/api/v1/practitioner/service/${serviceId}/${statusFlag}`;
    const response = await drpServicesServiceApiInstance.put<ServiceDetailI>(endpoint);
    return response.data;
}

export async function deleteServiceDetail( serviceId: string): Promise<ServiceDetailI> {
    const endpoint = `/api/v1/practitioner/service/${serviceId}`;
    const response = await drpServicesServiceApiInstance.delete<ServiceDetailI>(endpoint);
    return response.data;
}